import { useSession } from '@rewardops/auth'

import { updateSession } from '~/utils/session-utils'
import { useApi } from './use-api' // Adjust the import path accordingly

function useRefreshMemberPoints() {
  const { api } = useApi()
  const { setTrigger: sessionTrigger } = useSession()

  const sessionQuery = api.auth.getSession.useQuery()
  const pointsQuery = api.auth.getMemberPoints.useQuery()

  const refreshPointsMutation = api.auth.refreshMemberPoints.useMutation({
    onSuccess: async (points) => {
      await sessionQuery.refetch()
      await pointsQuery.refetch()

      await updateSession('PUT', { points }, sessionTrigger)
    },
  })

  const refreshPoints = async () => {
    await refreshPointsMutation.mutateAsync()
  }
  return { refreshPoints }
}

export default useRefreshMemberPoints
